(() => {
  function init(root){
    if(root.dataset.brandReady)return;
    root.dataset.brandReady='true';
    const stage=root.querySelector('[data-brand-stage]'),originals=[...stage.querySelectorAll('[data-brand-row]')],controller=new AbortController(),signal=controller.signal,reduced=matchMedia('(prefers-reduced-motion: reduce)');
    const names=originals.map(row=>row.querySelector('.skull-brand-name').textContent.replace('®','').trim()),rows=[...originals];
    for(let copy=0;copy<2;copy++)for(const original of originals){const clone=original.cloneNode(true);clone.dataset.brandClone='';stage.append(clone);rows.push(clone);}
    const mod=(value,count)=>((value%count)+count)%count;
    let phase=0,spacing=30,timer=0,inView=false,running=false,remaining=1000,nextAt=0,animations=[];
    function pose(index,position){
      const distance=mod(index-position+rows.length/2,rows.length)-rows.length/2,depth=Math.abs(distance),scale=Math.max(.4,1-depth*.43),opacity=Math.max(0,1-depth*.68);
      return {transform:`translate3d(0, calc(-50% + ${distance*spacing}px), 0) scale(${scale})`,opacity:String(opacity)};
    }
    function stopAnimations(){animations.forEach(animation=>animation.cancel());animations=[];}
    function render(animate=false,from=phase){
      stopAnimations();
      rows.forEach((row,index)=>{
        const end=pose(index,phase);
        row.style.transform=end.transform;row.style.opacity=end.opacity;
        row.toggleAttribute('data-brand-active',mod(index-phase,rows.length)===0);
        if(animate)animations.push(row.animate([pose(index,from),end],{duration:440,easing:'cubic-bezier(.4,0,.2,1)'}));
      });
      root.dataset.activeBrand=names[mod(phase,names.length)];
      root.dispatchEvent(new CustomEvent('skull:brand-title',{bubbles:true,detail:{index:mod(phase,names.length),changedAt:performance.now()}}));
    }
    function arm(){
      clearTimeout(timer);
      if(running)timer=setTimeout(advance,Math.max(0,nextAt-performance.now()));
    }
    function advance(){
      if(!running)return;
      const from=phase;phase=mod(phase+1,rows.length);render(true,from);
      nextAt+=1000;
      if(nextAt<=performance.now())nextAt=performance.now()+1000;
      remaining=1000;arm();
    }
    function sync(){
      const shouldRun=inView&&!document.hidden&&!reduced.matches;
      if(shouldRun===running)return;
      running=shouldRun;
      if(running){animations.forEach(animation=>{if(animation.playState==='paused')animation.play();});nextAt=performance.now()+remaining;arm();}
      else{remaining=Math.max(0,nextAt-performance.now());clearTimeout(timer);animations.forEach(animation=>{if(animation.playState==='running')animation.pause();});}
    }
    const resize=new ResizeObserver(()=>{
      const next=parseFloat(getComputedStyle(root).getPropertyValue('--brand-step'))||30;
      if(next!==spacing){spacing=next;render();}
    });resize.observe(root);
    const observer=new IntersectionObserver(([entry])=>{inView=entry.isIntersecting;sync();});observer.observe(root);
    document.addEventListener('visibilitychange',sync,{signal});
    reduced.addEventListener('change',()=>{if(reduced.matches)render();sync();},{signal});
    document.addEventListener('shopify:section:unload',event=>{if(!event.target.contains(root))return;clearTimeout(timer);stopAnimations();observer.disconnect();resize.disconnect();controller.abort();rows.slice(3).forEach(row=>row.remove());delete root.dataset.brandReady;},{signal});
    spacing=parseFloat(getComputedStyle(root).getPropertyValue('--brand-step'))||30;render();
  }
  document.querySelectorAll('[data-brand-rotor]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-brand-rotor]').forEach(init));
})();
